import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'formly-field-typeahead',
  styleUrls: ['./typehead.component.scss'],
  templateUrl: './typehead.component.html'
})
export class TypeheadComponent extends FieldType implements OnInit, OnDestroy {
  onDestroy$ = new Subject<void>();
  search$ = new EventEmitter();
  options$;

  getLabel(data) {
    return typeof this.to.labelProp === 'function' ? this.to.labelProp(data) : data[this.to.labelProp];
  }

  onScrollToEnd() {
    if (this.to.onScrollEnd) {
      this.to.onScrollEnd();
    }
  }

  ngOnInit() {
    this.options$ = this.search$;
    if (this.to.onSearchPhrase) {
      this.options$ = this.options$.pipe(
        tap((v) => this.to.onSearchPhrase(v)),
      );
    }
    this.options$ = this.options$.pipe(
      takeUntil(this.onDestroy$),
      startWith(''),
      filter(v => v !== null),
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(this.to.search$),
    );

    this.options$.subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
